import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useModalRouter from 'hooks/useModalRouter';

import ImportDataModal from 'modals/ImportDataModal';

import { importActions } from 'pages/Settings/ImportExport/ImportLog/ImportLogList';

import { ENUMS, USERS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faDownload, faPlus } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author Burak Unsal
 */
const UserList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50, show: false },
			{
				Header: 'fullName',
				accessor: 'fullName',
				filterType: FilterType.string,
				width: 120,
				renderCell: ListComponents.PROFILE_IMAGE,
				showOnMobile: true
			},
			{ Header: 'email', accessor: 'email', filterType: FilterType.string, width: 100 },
			{
				Header: 'phone',
				accessor: 'phone',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.PHONE
			},
			{
				Header: 'userType',
				accessor: 'type',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.V2_USER_TYPES,
				width: 100
			},
			// commented because of the backend bug.
			// do not uncomment until backend fix the bug.
			// if you want to uncomment, you need to meet the OMER UZAR and ask him to fix the bug.
			// {
			// 	Header: 'assignedLocations',
			// 	accessor: 'assignedLocations',
			// 	filterType: FilterType.string,
			// 	width: 100
			// },
			{ Header: 'jobTitle', accessor: 'jobTitle', filterType: FilterType.string, width: 100, show: false },
			{
				Header: 'hasCustomRole',
				accessor: 'hasCustomRole',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO,
				width: 100,
				roleName: 'CustomizableRoleModule',
				renderCell: ListComponents.STATUS
			},
			{ Header: 'userCode', accessor: 'userCode', filterType: FilterType.string },
			{
				Header: 'roleTemplateName',
				accessor: 'roleTemplateName',
				filterType: FilterType.multiSelection,
				width: 100,
				roleName: 'CustomizableRoleModule'
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.USER_STATUSES,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'updatedAt',
				accessor: 'updatedAt',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				width: 100,
				show: false
			},
			{
				Header: '2faStatus',
				accessor: '2FAStatus',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			}
		],
		[]
	);
	const { showModal } = useModalRouter();

	return (
		<div>
			<PageHeader
				title="users"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/users-icon.json.gz">
				<Authorization path="/import-export/button/userImport">
					<Button
						className="mobile-hidden importDataButton"
						icon={faDownload}
						variant="borderless"
						label="uploadUser"
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importData-icon.json.gz"
						onClick={() => NiceModal.show(ImportDataModal, importActions.userImport)}
					/>
				</Authorization>
				<Authorization path="/modal/user-form">
					<Button
						icon={faPlus}
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						label="addUser"
						onClick={() => showModal('user-form')}
						variant="blue"
						className="addButton"
					/>
				</Authorization>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.USERS}
				columns={columns}
				fetchUrl={USERS.GET_USER_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.USER}
				exportName="users"
			/>
		</div>
	);
};

export default UserList;
